import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import DashboardLayout from './Dashboard/Layout/DashboardLayout';
import LoadingWrapper from './Dashboard/Functions/LoadingWrapper';
import PpeStatusInfo from './Dashboard/Widget/PpeStatusInfo';
import PpeReasonInfo from './Dashboard/Widget/PpeReasonInfo';
import PpeEstablishmentInfo from './Dashboard/Widget/PpeEstablishmentInfo';
import PpeCompanyInfo from './Dashboard/Widget/PpeCompanyInfo';
import LatestAssignments from './Dashboard/Widget/LatestAssignments';
import AssignedItems from './Dashboard/Widget/AssignedItems';
import { useParams } from 'react-router-dom';
import useRedirectEstablishmentActiveContent from '../../Components/Hooks/useRedirectEstablishmentActiveContent';
import EstablishmentAssignedItems from './Dashboard/Widget/EstablishmentAssignedItems';


const PersonalProtectiveEquipmentDashboardCenter = () => {
  const { id } = useParams();
  const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/supply/ppe/summary/center/establishmentId');


  return (<DashboardLayout title={'Panel de Gestión de EPP'} hiddenTitle={true}>
    <React.Fragment>
      <Row className='m-0 p-0'>
        <Col md={4} className='m-0 p-0 h-100'>
          <Row className='m-0 p-0 h-100'>
            <Col md={6} sm={3} className='m-0 p-1'>
              <PpeStatusInfo establishment_id={id} title={'Total por Estado'} />
            </Col>
            <Col md={6} sm={3} className='m-0 p-1'>
              <PpeReasonInfo establishment_id={id} title={'Total por Motivo de Asignación'} />
            </Col>
          </Row>

          <Row className='m-0 p-0 h-100'>
            <Col md={12} sm={3} className='m-0 p-1'>
              <LatestAssignments establishment_id={id} title={'Últimas 10 asignaciones'} />
            </Col>
          </Row>
        </Col>
        <Col md={3} className='m-0 p-0 h-100'>
          <Row className='m-0 p-0 h-100'>
            <Col md={12} sm={3} className='m-0 p-1 h-100'>
              <AssignedItems establishment_id={id} title={'Elementos Asignados'} />
            </Col>
          </Row>
        </Col>
        <Col md={5} className='m-0 p-0 h-100'>
          <Row className='m-0 p-0'>
            <Col md={12} sm={12} className='m-0 p-1'>
              <EstablishmentAssignedItems establishment_id={id} title={'Asignaciónes del Establecimiento'} />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  </DashboardLayout>
  );
};

export default PersonalProtectiveEquipmentDashboardCenter;
